import React from 'react';
import {
    StyledLoginButton,
    StyledLoginTextField,
} from '../styledMaterialComponents/styledMaterialComponents';
import FormControl from '@material-ui/core/FormControl';
import styles from './loginForm.module.css';

const loginForm = ({
    register,
    onLoginButtonClick,
    onPasswordChange,
    onRegisterButtonClick,
    onEmailChange,
    onPasswordRepeatChange,
    alert,
}) => {
    const onKeyPress = event => {
        if (event.key === 'Enter') {
            onLoginButtonClick();
        }
    };
    return (
        <div className={styles.loginForm} onKeyPress={onKeyPress}>
            <div className={styles.loginFormTitle}>Zaloguj się</div>
            <FormControl>
                <StyledLoginTextField
                    onChange={onEmailChange}
                    className={styles.username}
                    label="Wpisz swój e-mail"
                />
                <StyledLoginTextField
                    onChange={onPasswordChange}
                    className={styles.password}
                    type="password"
                    label="Wpisz swoje hasło"
                />
                {register && (
                    <StyledLoginTextField
                        onChange={onPasswordRepeatChange}
                        className={styles.password}
                        type="password"
                        label="Powtórz swoje hasło"
                    />
                )}
            </FormControl>
            <div className={styles.loginFormErrorMessage}>{alert}</div>
            <StyledLoginButton
                variant="contained"
                color="primary"
                size="large"
                onClick={onRegisterButtonClick}>
                {register ? 'Masz konto? Zaloguj się!' : 'Nie masz konta? Zarejestruj się!'}
            </StyledLoginButton>
            <StyledLoginButton
                variant="contained"
                color="primary"
                size="large"
                onClick={onLoginButtonClick}>
                {register ? 'Zarejestruj się' : 'Zaloguj się'}
            </StyledLoginButton>
        </div>
    );
};

export default loginForm;
